export const MODIF_VJSF_CONSTANTS = {
  PREFIX_NAME: { CUSTOM: "custom-" },
  EVENT: {
    INPUT: "input",
    BLUR: "blur",
    ON_REQUIRED_COMPLETE: "onRequiredComplete"
  },
  TYPE: {
    NUMBER: {
      MAX_LENGTH: 14
    },
    PHONE: {
      COLOR: {
        SUCCESS: "#0B3352",
        WARNING: "red"
      }
    }
  },
  PATH: "path",
  CUSTOM_AUTOCOMPLETE: "custom-autocomplete",
  CUSTOM_STRING: "custom-string",
  CUSTOM_SELECT: "custom-select",
  TEXT_AREA: "textarea"
};
